import React, { useEffect, useState } from 'react';
import { Row, Col, Card, Space, DatePicker, Drawer, Form, Input, Select, Radio, message, Modal, Pagination, Tabs } from 'antd';
import { Table, Button } from 'antd';
import BreadcrumbCustom from '../../components/widget/BreadcrumbCustom';
import { DownOutlined, ExclamationCircleOutlined, PlusOutlined } from '@ant-design/icons';
import { IClassroom, listAllClassroomsByStoreId, createClassroom, updateClassroom, enableClassroom, pageClassrooms } from '../../service/api/classroom';
import moment from 'moment';
// import { SketchPicker } from 'react-color';
import { IStore, listStores } from '../../service/api/store';
import { FormInstance } from 'antd/lib/form/Form';
import { Link } from 'react-router-dom';
const { confirm } = Modal;
const { Option } = Select;

function getUrlParam(name: string, str: string) {
  const paramUrl = str.split('?');
  const params = paramUrl[1].split('&');
  for (var i = 0; i < params.length; i++) {
    const value = params[i].split('=');
    if (value[0] == name) {
      return value[1];
    }
  }
  return null;
}

const StoreClassroomList = (props: any) => {
  const [classrooms, setClassrooms] = useState<IClassroom[]>();
  const [stores, setStores] = useState<IStore[]>();
  const [storeId, setStoreId] = useState<any>();
  const [classroomVisible, setClassroomVisible] = useState(false);
  const [classroomDetail, setClassroomDetail] = useState<IClassroom>();
  const [pageNum, setPageNum] = useState(1);
  const [pageTotal, setPageTotal] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const [loading, setLoading] = useState(false);
  const formRef = React.createRef<FormInstance>();

  const columns = [
    {
      title: '名称',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: '备注',
      dataIndex: 'remark',
      key: 'remark',
    },
    {
      title: '状态',
      dataIndex: 'enable',
      key: 'enable',
      render: (text: any, record: any) => {
        if (record.enable) {
          return <span style={{ color: 'green' }}>使用中</span>
        } else {
          return <span style={{ color: 'grey' }}>已停用</span>
        }
      }
    },
    {
      title: '操作',
      key: 'action',
      render: (text: any, record: any) => {
        if (record.enable) {
          return <Space size="middle">
            <a onClick={() => {
              setClassroomDetail(record);
              setClassroomVisible(true);
            }}>编辑 </a>
            <a onClick={e => { onEnable(e, record) }}>停用 </a>
          </Space>
        } else {
          return <Space size="middle">
            <a onClick={() => {
              setClassroomDetail(record);
              setClassroomVisible(true);
            }}>编辑 </a>
            <a onClick={e => { onEnable(e, record) }}>启用 </a>
          </Space>
        }
      },
    }

  ];

  useEffect(() => {
    loadData();
  }, [pageNum, pageSize]);

  useEffect(() => {
    if (classroomDetail) {
      // 设置100毫秒的延迟 确保from组件已经加载完毕
      setTimeout(() => {
        formRef.current!.setFieldsValue(classroomDetail);
      }, 100);
    }
  }, [classroomDetail]);

  const loadData = () => {
    setStoreId(getUrlParam('storeId', window.location.href));
    listAllClassroomsByStoreId(getUrlParam('storeId', window.location.href)).then((info: any) => {
      setClassrooms(info?.data);
    });
    listStores().then((info: any) => {
      setStores(info.data);
    });
  }

  const onFinish = (values: any) => {
    setLoading(true);
    if (classroomDetail) {
      updateClassroom({
        ...values,
        storeId: storeId,
        id: classroomDetail.id
      }).then((info: any) => {
        console.log("info:" + JSON.stringify(info));
        if (info) {
          message.success("更新成功");
          onClose();
          setLoading(false);
          loadData();
        }
      });
    } else {
      createClassroom({
        ...values,
        storeId: storeId,
      }).then((info: any) => {
        console.log("info:" + JSON.stringify(info));
        if (info) {
          message.success("创建成功");
          onClose();
          setLoading(false);
          loadData();
        }
      });
    }
  };

  const onEnable = (e: any, item: IClassroom) => {
    e.stopPropagation();
    confirm({
      title: '提示',
      icon: <ExclamationCircleOutlined />,
      content: item.enable ? '确定要停用该教室吗？停用后无法被选到' : '确定要启用该教室吗？',
      okText: '确定',
      okType: 'danger',
      cancelText: '取消',
      onOk() {
        enableClassroom(item.id, !item.enable).then((info: any) => {
          if (info) {
            message.success("操作成功");
            loadData();
          }
        });
      },
      onCancel() {
      },
    });
  }

  const onClose = () => {
    setClassroomDetail(undefined);
    setClassroomVisible(false);
    if (formRef.current) {
      formRef.current!.resetFields();
    }
  }

  const onPageChange = (pageNum: number, pageSize?: number) => {
    console.log("pageNum:" + pageNum);
    console.log("pageSize:" + pageSize);
    setPageNum(pageNum);
    setPageSize(pageSize || 10);
    // setPageSize(info.data.pageSize);
  }

  // 下拉框值
  const storeOptions = stores?.map((store) =>
    <Option key={store.id} value={store.id}>{store.name}</Option>);

  return (
    <Card bordered={false}>
      <BreadcrumbCustom breads={[<Link to={'/app/store'}>门店管理</Link>, '教室管理']} />
      <Row gutter={16}>
        <Col className="gutter-row" md={24}>
          <div className="gutter-box">
            <Card title={decodeURI(getUrlParam('storeName', window.location.href)!)} bordered={false} extra={
              <div>
                <Button type="primary" onClick={() => {
                  setClassroomVisible(true);
                }} icon={<PlusOutlined />}>
                  新增教室
                  </Button>
              </div>
            }>
              <Table dataSource={classrooms} columns={columns} pagination={false} />
            </Card>
          </div>
        </Col>
      </Row>
      <Drawer
        title={classroomDetail ? "编辑教室" : "新增教室"}
        visible={classroomVisible}
        width={720}
        onClose={onClose}
        bodyStyle={{ paddingBottom: 80 }}
        destroyOnClose
      >
        <Form onFinish={onFinish} ref={formRef} layout="vertical" hideRequiredMark>
          <Row gutter={16}>
            <Col span={24}>
              <Form.Item
                name="name"
                label="名称"
                rules={[{ required: true, message: '请输入名称' }]}
              >
                <Input placeholder="请输入名称" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="remark"
                label="备注"
                rules={[{ required: false, message: '请输入备注' }]}
              >
                <Input placeholder="请输入备注" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="color"
                label="班级颜色（用于排课视图）"
                rules={[{ required: true, message: '颜色编码：#000000' }]}
              >
                {/* <SketchPicker onChangeComplete={setColor}/> */}
                <Input placeholder="颜色编码：#000000" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={24}>
              <Form.Item>
                <Button type="primary" htmlType="submit" loading={loading}>保存</Button>
                <Button htmlType="button" onClick={onClose}>取消</Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Drawer>
    </Card>
  );
};

export default StoreClassroomList;
